export function majorRend(key) {
  return [key, key + 4, key + 7];
}

export function minorRend(key) {
  return [key, key + 3, key + 7];
}

export function seventhRend(key) {
  return [key, key + 4, key + 7, key + 10];
}

export function susRend(key, ext) {
  return [key, key + ext, key + 7];
}
